import { categories } from "@/mocks/cases";

interface ArchiveFiltersProps {
  activeCat: string;
  query: string;
  counts: Record<string, number>;
  total: number;
  onCatChange: (id: string) => void;
  onQueryChange: (value: string) => void;
}

export default function ArchiveFilters({
  activeCat,
  query,
  counts,
  total,
  onCatChange,
  onQueryChange,
}: ArchiveFiltersProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="档案分类筛选">
        {categories.map((cat) => {
          const count = cat.id === "all" ? total : counts[cat.id] ?? 0;
          const active = activeCat === cat.id;
          return (
            <button
              key={cat.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onCatChange(cat.id)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {cat.name}
              <span className={`text-xs ${active ? "text-background-50/80" : "text-foreground-400"}`}>{count}</span>
            </button>
          );
        })}
      </div>

      <div className="relative w-full lg:w-72 shrink-0">
        <span className="absolute left-3.5 top-1/2 -translate-y-1/2 flex w-4 h-4 items-center justify-center text-foreground-400">
          <i className="ri-search-line text-base" />
        </span>
        <input
          type="search"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="搜索标题、标签或关键词"
          aria-label="搜索档案"
          className="w-full pl-10 pr-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
        />
      </div>
    </div>
  );
}